import { extend, $$, addEvent, $ } from './helper-functions'

export class ButtonSearch {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.button--search',
      focusTarget: '.modal--search input.orig'
    }, selectors)

    this.classes = extend({}, classes)
  }

  init () {
    this.$searchButtons = $$(this.selectors.block)
    this.$focusTarget = $(this.selectors.focusTarget)
    this.events()
  }

  events () {
    const that = this

    that.$searchButtons.forEach((searchButton) => {
      addEvent(searchButton, 'click', () => {
        window.setTimeout(() => {
          if (this.$focusTarget && searchButton.getAttribute('aria-expanded') === 'true') {
            this.$focusTarget.focus()
          }
        }, 100)
      })
    })
  }
}

export default ButtonSearch
